import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RaceProgram } from "@tvg/ts-types/Race";
import capiServices from "@tvg/api/capi";
import { getStoredFreePastPerformace } from "../store/selectors";
import { setFreePastPerformances } from "../store/actions";

interface Response {
  data: Record<string, string>[];
}

const useFreePastPerformance = (currentRace: RaceProgram) => {
  const dispatch = useDispatch();
  const [localFpp, setLocalFpp] = useState<Record<string, string>[]>([]);
  const freePastPerformances = useSelector(getStoredFreePastPerformace);
  useEffect(() => {
    if (!freePastPerformances.length) {
      capiServices.fetchFreePastPerfomances().then((res: Response) => {
        dispatch(setFreePastPerformances(res.data));
        setLocalFpp(res.data);
      });
    }
  }, [currentRace.track?.trackName]);
  const proccessCurrentFpp = (
    tracks: Record<string, string>[],
    race: RaceProgram
  ) =>
    tracks.find(
      (fpp: Record<string, string>) =>
        race.track?.trackCode && fpp.trackCode === race.track.trackCode
    ) || null;

  if (localFpp.length) {
    if (currentRace.track && currentRace.track.trackCode) {
      const currentFpp = proccessCurrentFpp(localFpp, currentRace);

      return [currentFpp];
    }
  } else if (
    currentRace.track &&
    currentRace.track.trackCode &&
    freePastPerformances.length
  ) {
    const currentFpp = proccessCurrentFpp(freePastPerformances, currentRace);

    return [currentFpp];
  }

  return [null];
};

export default useFreePastPerformance;
